export default __webpack_public_path__ + "static/media/edem.dd923b06.png";